export enum enumStatus {
  'Reject' = 1,
  'Accept',
  'Transfer to Suspense Account'
}

export namespace enumStatus {
  export function values() {
    return Object.keys(enumStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
